import { HStack, Text } from '@chakra-ui/react';
import { Link as LinkIcon } from 'iconoir-react';
import { ClipboardCopyButton } from './clipboard-button';

interface CopyLinkFieldProps {
  /** The URL to display and copy. */
  value: string;
  /** Localized label of the copy button (the atom stays i18n-agnostic). */
  copyLabel: string;
}

/**
 * The shareable-link field: a bordered row with a link glyph, the truncated URL
 * and an attached solid Copy button. Extracted verbatim from the collab
 * done-step (the reference render) so every surface that hands a link over
 * shows the same affordance. Borders + background contrast, no shadow.
 */
export const CopyLinkField = ({ value, copyLabel }: CopyLinkFieldProps) => (
  <HStack
    w="full"
    gap="2"
    borderWidth="1px"
    borderColor="cardBorder"
    bg="background"
    rounded="lg"
    pl="12px"
    pr="6px"
    py="6px"
  >
    <Text color="fg.muted" display="inline-flex" flex="none">
      <LinkIcon width={14} height={14} />
    </Text>
    <Text fontSize="12.5px" color="primary.600" truncate flex="1" textAlign="left">
      {value}
    </Text>
    <ClipboardCopyButton value={value} size="sm" colorPalette="primary" label={copyLabel} />
  </HStack>
);
